/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-16 13:55:15
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-16 14:42:56
 */
import http from '@/axios/index'

/**
 * @brief: 获取养殖平台的平台权限菜单列表
 * @author: Scarlett Xiao
 * @Date: 2022-03-16 13:55:53
 * @param {*} userCode 用户帐号
 */
export function getPlatformAuthority(userCode) {
  const url = '/user/queryUserAccountPlatformManagement';
  return http.post(url, {
    userAccount: userCode
  });
}
/**
 * @brief: 获取用户信息
 * @author: Scarlett Xiao
 * @Date: 2022-03-16 14:42:06
 */
export function getUserInfo() {
  const url = '/user/getUserInfoByToken';
  return http.get(url);
}